import { render } from "./ApproveFundsPage.vue?vue&type=template&id=2b7b799b"
import script from "./ApproveFundsPage.vue?vue&type=script&lang=js"
export * from "./ApproveFundsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__